export const reporters = (): string => '/api/reporters'

export const reporter = (id: string): string => `/api/reporters/${id}`

export const adminEvents = (): string => `/api/admins/events`

export const calendarAdminEvents = (): string => `/api/v2/admins/events`

export const calendarAdminCourtReporterEvents = (): string =>
  `/api/v2/admins/court-reporter-events`

export const adminEvent = (id: string): string => `/api/admins/events/${id}`

export const adminCourtReporters = (): string => `/api/admins/court-reporters`

export const adminCourtReporterEvent = (id: string): string =>
  `/api/admins/court-reporter-events/${id}`

export const courtReporter = (id: string): string =>
  `/api/court-reporters/${id}`

export const courtReporterEvents = (court_reporter_id: string): string =>
  `/api/court-reporters/${court_reporter_id}/events`

export const courtReporterEvent = (
  court_reporter_id: string,
  id: string,
): string => `/api/court-reporters/${court_reporter_id}/events/${id}`

export const reporterEvents = (reporter_id: string): string =>
  `/api/reporters/${reporter_id}/events`

export const calendarReporterEvents = (reporter_id: string): string =>
  `/api/v2/reporters/${reporter_id}/events`

export const reporterWaitingEvents = (reporter_id: string): string =>
  `/api/reporters/${reporter_id}/events/waiting`

export const reporterAvailableEvents = (reporter_id: string): string =>
  `/api/reporters/${reporter_id}/events/available`

export const reporterEvent = (reporter_id: string, id: string): string =>
  `/api/reporters/${reporter_id}/events/${id}`

export const eventZoombotStatus = (event_id: string) =>
  `/api/events/${event_id}/zoombot-status`

export const eventNewZoomParticipants = (event_id: string) =>
  `/api/events/${event_id}/participants`
